// @flow
import React, { useEffect } from "react";
import * as serviceWorker from "../serviceWorker";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";

/**
 * learned from
 * https://felixgerschau.com/create-a-pwa-update-notification-with-create-react-app/
 */
function UpdatePWA() {
  const [showReload, setShowReload] = React.useState(false);
  const [
    waitingWorker,
    setWaitingWorker,
  ] = React.useState<ServiceWorker | null>(null);

  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    if (registration != null) {
      setShowReload(true);
      setWaitingWorker(registration.waiting);
    } else {
      console.error("Missing ServiceWorkerRegistration");
    }
  };

  useEffect(() => {
    serviceWorker.register({ onUpdate: onSWUpdate });
  }, []);

  const reloadPage = () => {
    if (waitingWorker != null) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      setShowReload(false);
    } else {
      console.error("Missing waitingWorker");
    }
    window.location.reload(true);
  };

  return (
    <Snackbar
      open={showReload}
      message="🥳 Neue Version verfügbar"
      onClick={reloadPage}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      action={
        <Button color="secondary" size="small" onClick={reloadPage}>
          Starten
        </Button>
      }
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    />
  );
}

export default UpdatePWA;
